import { PlacementRuleType } from '../../../api/generated';
import type { EditorDayKey } from './types';

export const DEP_LABEL_KEYS: Record<PlacementRuleType, string> = {
  FIRST: 'config-dep-label-first',
  LAST: 'config-dep-label-last',
  BEFORE: 'config-dep-label-before',
  AFTER: 'config-dep-label-after',
  IMMEDIATELY_BEFORE: 'config-dep-label-immediately-before',
  IMMEDIATELY_AFTER: 'config-dep-label-immediately-after'
};

export const DEP_OPTIONS: PlacementRuleType[] = [
  'FIRST',
  'LAST',
  'AFTER',
  'BEFORE',
  'IMMEDIATELY_AFTER',
  'IMMEDIATELY_BEFORE'
];

// Chain layout geometry (px). Must stay in sync with the connector widths in
// InterventionGraphEditor.module.css. A normal "after/before" connector is
// wide; an "immediately after/before" connector is tighter (less gap) but still
// leaves space so the boxes don't touch.
export const NODE_WIDTH = 240;
export const CONNECTOR_WIDTH = 72;
export const CONNECTOR_TIGHT_WIDTH = 36;

// Minimum horizontal control-point offset for the diagonal branch connectors,
// so near-vertical links (a node wrapped directly below its neighbour) still
// curve smoothly instead of collapsing into a straight vertical line.
export const CONNECTOR_MIN_CURVE = 32;

// Horizontal offset where a cross-row link rises out of the gutter into its
// endpoints. Kept smaller than the tight connector so the rise happens beside
// the target card, never over the neighbouring card.
export const CONNECTOR_GUTTER_CURVE = 28;

// TODO: extend to Saturday/Sunday when the backend day schedule is widened.
export const WEEKDAYS: EditorDayKey[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];

export const DAY_SHORT: Record<EditorDayKey, string> = {
  MONDAY: 'Mo',
  TUESDAY: 'Tu',
  WEDNESDAY: 'We',
  THURSDAY: 'Th',
  FRIDAY: 'Fr'
};
